import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between" }
const _hoisted_2 = { class: "font-size-16-600 mt-1" }
const _hoisted_3 = {
  key: 0,
  class: "font-size-10-600"
}
const _hoisted_4 = { class: "font-size-12-400 mt-1" }
const _hoisted_5 = { class: "d-flex align-center ga-4" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "avatar-container__initials primary-background-button-color"
}
const _hoisted_8 = {
  key: 1,
  class: "font-size-12-600"
}
const _hoisted_9 = { key: 3 }

import {firstLetterUppercase} from "@/components/Helpers/Utils";
import moment from "moment/moment";
import Icon from "@/components/Icons/Icon.vue";
import {computed} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingHeader',
  props: {
  service: {
    type: Object,
  },
  booking: {
    type: Object,
  },
  settingsStore: {
    type: Object,
  },
  tab: {
    type: String,
  },
},
  setup(__props) {

const props = __props

const getAvatar = computed(() => {
  const creator = props.booking.practitioner;
  if (creator) {
    const firstName = creator.first_name ?? '';
    const lastName = creator.last_name ?? '';

    return creator.image
        ? {image: creator.image.file?.file_path ?? '', initials: null}
        : {image: null, initials: (firstName[0] + (lastName[0] || '')).toUpperCase()};
  }
  return null;
});

const getDurations = computed(() => {
  return props.service?.booking_options?.duration
      ? `${props.service.booking_options.duration} min${props.service.booking_options.duration > 1 ? 's' : ''}`
      : 'Duration not specified';
});

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mt-2 mx-2 mb-2 pa-4 border-rounded" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "font-size-12-600 primary-color" }, "My selection", -1)),
          _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(firstLetterUppercase)(__props.service?.name)), 1),
          (__props.service?.package_name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " (" + _toDisplayString(_unref(firstLetterUppercase)(__props.service?.package_name)) + ") ", 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(getDurations.value) + " ", 1),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-success" }, "|", -1)),
            _createTextVNode(" " + _toDisplayString(__props.service?.price_display), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (getAvatar.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_sheet, { class: "avatar-container" }, {
                  default: _withCtx(() => [
                    (getAvatar.value?.image)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          style: _normalizeStyle({ backgroundImage: `url(${getAvatar.value.image})` }),
                          class: "avatar-container__image"
                        }, null, 4))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(getAvatar.value?.initials), 1))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (__props.booking.method && __props.tab.name === 'Date/Method' || __props.tab.name === 'Details')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (__props.booking.method === 'in_person')
                  ? (_openBlock(), _createBlock(Icon, {
                      key: 0,
                      color: __props.settingsStore.settings.primaryColor,
                      icon: "location-icon"
                    }, null, 8, ["color"]))
                  : _createCommentVNode("", true),
                (__props.booking.method === 'phone')
                  ? (_openBlock(), _createBlock(Icon, {
                      key: 1,
                      color: __props.settingsStore.settings.primaryColor,
                      icon: "phone-icon"
                    }, null, 8, ["color"]))
                  : _createCommentVNode("", true),
                (__props.booking.method === 'video')
                  ? (_openBlock(), _createBlock(Icon, {
                      key: 2,
                      color: __props.settingsStore.settings.primaryColor,
                      icon: "video-icon"
                    }, null, 8, ["color"]))
                  : _createCommentVNode("", true),
                ( __props.booking.date)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("p", null, _toDisplayString(__props.booking.time), 1),
                      _createElementVNode("p", null, _toDisplayString(_unref(moment)(__props.booking.date).format('D MMM YYYY')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})